import { FeatureFlag } from '../FeatureFlag';

export const enableLab2AutoAccept = new FeatureFlag({
    key: 'enable-lab-2-auto-accept',
    createdOn: '2025-11-19',
    defaultValue: false,
});
